import React from 'react';

import AdminPage from '../../styles/templates/AdminPage';
import { CrmProjectOverviewPage } from '../CRM';

const AdminProjectOverviewPage: React.FC = () => (
  <AdminPage>
    <CrmProjectOverviewPage />
  </AdminPage>
);

export default AdminProjectOverviewPage;
